import _ from 'lodash'
import axios from 'axios'
import AppConfig from '../../../libs/AppConfig'
import { getInstance } from './Auth0'

export default class HttpRequest {
  /**
   * @var {Headers}
   */
  headers = {};

  /**
   * @constructor
   * @param {string} service
   */
  constructor (service, version = 1) {
    this.service = service
    this.version = version
  }

  /**
   *
   */
  get (action, params = {}) {
    return this.request('get', action, {}, params)
  }

  /**
   *
   */
  post (action, payload = {}, params = {}) {
    return this.request('post', action, payload, params)
  }

  /**
   *
   */
  put (action, payload = {}, params = {}) {
    return this.request('put', action, payload, params)
  }

  /**
   *
   */
  destroy (action, params = {}) {
    return this.request('delete', action, {}, params)
  }

  /**
   *
   */
  save (payload = {}, params = {}) {
    const id = _.get(payload, '_id')

    return id ? this.put(id, payload, params) : this.post('', payload, params)
  }

  /**
   *
   */
  async request (method = '', action = '', payload = {}, params = {}) {
    const endpoint = this.getEndpoint(action)
    const headers = await this.getHeaders()
    const options = {
      headers,
      params
    }

    if (['get', 'delete'].includes(method)) {
      return axios[method](endpoint, options)
    }
    return axios[method](endpoint, payload, options)
  }

  /**
   *
   */
  getEndpoint (action = '') {
    return `//${AppConfig.get('api_uri')}/v${this.version}/${this.service}/${action}`
  }

  /**
   * @returns {Headers}
   */
  async getHeaders () {
    this.headers = {}

    if (getInstance().isAuthenticated) {
      const token = await getInstance().getTokenSilently()

      if (token) {
        this.headers.Authorization = `Bearer ${token}`
      }
    }

    return this.headers
  }
}
